import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const COLORS = {
  approved: '#2C5F34',
  rejected: '#FF0000',
  pending: '#FFCE1B',
};

const truncate = (text: string, limit: number = 10) => {
  return text.length > limit ? text.substring(0, limit) + '...' : text;
};

const LegendItem = ({ color, label }: { color: string; label: string }) => (
  <div className="flex items-center gap-2">
    <span
      className="w-3 h-3 rounded-full"
      style={{ backgroundColor: color }}
    />
    <span className="text-sm font-medium">{label}</span>
  </div>
);

interface MeetingByAgendaProps {
  meetingsByAgenda?: any[];
}

const MeetingByAgenda = ({ meetingsByAgenda = [] }: MeetingByAgendaProps) => {
  const fullLabels = meetingsByAgenda.map((item) => item.agenda);

  const truncatedLabels = fullLabels.map((label: string) =>
    truncate(label, 10)
  );

  const chartMinWidth =
    meetingsByAgenda.length > 6
      ? meetingsByAgenda.length * 140
      : '100%';

  const data = {
    labels: truncatedLabels,
    datasets: [
      {
        label: 'Approved',
        data: meetingsByAgenda.map((item) => item.approved || 0),
        backgroundColor: COLORS.approved,
        borderRadius: 6,
        barThickness: 25,
      },
      {
        label: 'Rejected',
        data: meetingsByAgenda.map((item) => item.rejected || 0),
        backgroundColor: COLORS.rejected,
        borderRadius: 6,
        barThickness: 25,
      },
      {
        label: 'Pending',
        data: meetingsByAgenda.map((item) => item.pending || 0),
        backgroundColor: COLORS.pending,
        borderRadius: 6,
        barThickness: 25,
      },
    ],
  };

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems: any) => {
            const index = tooltipItems[0].dataIndex;
            return fullLabels[index];
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#f0f0f0',
        },
      },
    },
  };

  return (
    <div className="w-full">


      <div className="flex justify-center items-center gap-8 mb-4 flex-wrap">
        <LegendItem color={COLORS.approved} label="Approved" />
        <LegendItem color={COLORS.rejected} label="Rejected" />
        <LegendItem color={COLORS.pending} label="Pending" />
      </div>

      <div className="w-full overflow-x-auto">
        <div
          style={{
            minWidth: chartMinWidth,
            height: '350px',
          }}
        >
          <Bar data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default MeetingByAgenda;
